import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CreateGates from 'components/sales/formSection/editPostSaleApt/materialHardwareSection/createGates';
import ProductInventory from 'components/sales/formSection/editPostSaleApt/materialHardwareSection/productInventory';
import ProductInventoryEdit from 'components/sales/formSection/editPostSaleApt/materialHardwareSection/productInventoryEdit';

const Inventory = ({
  data,
  handleGatesData,
  handleProductData,
  getMateriaById,
  getBrand,
  getBrandById,
  getMaterial,
  prefilledData,
  editProduct=false,
  commData
}) => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (data?.hardware_category?.product) {
      setProducts(data?.hardware_category?.product);
    }
  }, [data]);

  const handleremoveValue = (info) => {
    if (info[0].category_id !== '' && data?.hardware_category) {
      const { hardware_category } = data;
      const removedData = hardware_category.product.filter(
        (item) => item.id === info[0].category_id
      );
      setProducts([...products, ...removedData]);
    }
  };

  const handleDataFilter = (id) => {
    if (data?.hardware_category) {
      for (const obj of id) {
        if (obj?.category_id !== '') {
          const filterData = products.filter((item) => {
            return item.id !== obj.category_id;
          });
          setProducts(filterData);
        }
      }
    }
  };

  return (
    <Fragment>
      {/* <CreateGates data={data} handleValue={handleGatesData} prefilledData={prefilledData}/> */}
      {(editProduct && editProduct === true) ? 
          <ProductInventoryEdit
          data={products}
          getMaterial={getMaterial}
          getMateriaById={getMateriaById}
          handleValue={handleProductData}
          handleremoveValue={handleremoveValue}
          // handleDataFilter={handleDataFilter}
          prefilledData={prefilledData}
          getBrand={getBrand}
          getBrandById={getBrandById}
          commData={commData}
        />
      : 
          <ProductInventory
            data={products}
            getMaterial={getMaterial}
            getMateriaById={getMateriaById}
            handleValue={handleProductData}
            handleremoveValue={handleremoveValue}
            // handleDataFilter={handleDataFilter}
            prefilledData={prefilledData}
            getBrand={getBrand}
            getBrandById={getBrandById}
            commData={commData}
          />
      }
      
    </Fragment>
  );
};

Inventory.propTypes = {
  data: PropTypes.any,
  handleGatesData: PropTypes.func,
  handleProductData: PropTypes.func,
};

export default Inventory;
